import axios from 'axios'
import Account from './v2/Account'
import Publishers from './v2/Publishers'
import Support from './v2/Support'
import Users from './v2/Users'
import Listings from './v2/Listings'
import Charts from './v2/Charts'
import Messages from './v2/Messages'

/**
 * v2 API
 * @version  2
 */
export default class v2 {
  constructor(session) {
    const $axios = axios.create({
      baseURL: `${process.env.VUE_APP_API_HOST}/v2`,
    })

    // Run this each request since the token may change
    $axios.interceptors.request.use((config) => {
      config.headers['Authorization'] = `Bearer ${session.get('token')}`

      return config
    });

    // If we get a token back, update ours
    $axios.interceptors.response.use((response) => {
      let token = response.headers['x-adreplay-token']
      if(token) {
        session.setToken(token)
      }

      return response
    });

    this.Account = new Account($axios)
    this.Publishers = new Publishers($axios)
    this.Support = new Support($axios)
    this.Users = new Users($axios)
    this.Listings = new Listings($axios)
    this.Charts = new Charts($axios)
    this.Messages = new Messages($axios)
  }
}
